type BaseSettlementModel = {
  isin: string;
  isMaxQuantity: boolean;
  quantity: number;
};

export type TCashSettlementModel = BaseSettlementModel & {
  shareInProportion?: boolean;
};

export type TPhysicalSettlementModel = BaseSettlementModel & {
  physicalSettlementRequestForOutOfMoneyOrEvenContract?: boolean;
};

function baseSettlementFactory(model: BaseSettlementModel) {
  return {
    isin: model.isin,
    quantity: model.quantity,
    maximumQuantity: model.isMaxQuantity,
  };
}

export function cashSettlementFactory(formModel: TCashSettlementModel) {
  return {
    ...baseSettlementFactory(formModel),
    shareInProportion: formModel.shareInProportion ?? null,
  };
}

export function physicalSettlementFactory(formModel: TPhysicalSettlementModel) {
  return {
    ...baseSettlementFactory(formModel),
    requestedInCaseOfOtmOrAtm:
      formModel.physicalSettlementRequestForOutOfMoneyOrEvenContract ?? null,
  };
}
